import React from "react"
import {useTranslation} from "react-i18next"
import {useSnackbar} from "notistack"

// @ts-ignore
import FormSmallContainer from "../../../../../../../components/FormSmallContainer"
import {
  notifyForTmRevise,
  submitTmRevise,
  uploadTicketReviewProcessFiles,
} from "../../../../../../../api/ticketReviewProcess"
import {hasFilesForUpload} from '../../../../../../../util/file'
import OneTextFieldAndUploadForm, {OneTextFieldAndUploadFormFields} from '../../../../../../../forms/OneTextFieldAndUploadForm'



interface TmReviseFormProps {
  toggleFormOpen: () => void,
  ticketId: string,
  projectId: string,
  ticketActionChange: (new_action_id: number) => void
}

export default function TmReviseForm(props: TmReviseFormProps) {
  const { t } = useTranslation("private")
  const { enqueueSnackbar, closeSnackbar } = useSnackbar()

  const submitForm = async (values: OneTextFieldAndUploadFormFields): Promise<void> => {
    try {
      const {data: trp} = await submitTmRevise(props.ticketId, props.projectId, values)
      // upload files
      if (hasFilesForUpload(values.files)) {
        const uploadingKey = enqueueSnackbar('Uploading files...', {variant: 'info'})
        const fileUploadMessage = await uploadTicketReviewProcessFiles(values.files, props.projectId, trp.id)
        closeSnackbar(uploadingKey)
        enqueueSnackbar(
          fileUploadMessage.message,
          {
            variant: fileUploadMessage.error ? 'error' : 'success',
            style: {whiteSpace: 'pre-wrap'}
          }
        )
      }
      // notify of the approval and create history object
      await notifyForTmRevise(trp.id, props.projectId)
      if (trp?.new_action_id) {
        props.ticketActionChange(trp.new_action_id)
      }
      props.toggleFormOpen()
      enqueueSnackbar(t('view.Tickets.tm_revise_success'), {variant: "success"})
    } catch (_) {
      enqueueSnackbar(t('view.Tickets.tm_revise_fail'), {variant: "error"})
    }
  }

  return (
    <FormSmallContainer>
      <OneTextFieldAndUploadForm
        onCancel={props.toggleFormOpen}
        submitForm={submitForm}
        titleText={t('view.Tickets.tm_revise_title')}
        textFieldRequired={true}
      />
    </FormSmallContainer>
  )
}
